import React from 'react';
import './Teachers.css';
import dominiquePhoto from '../../assets/teachers/Dominique_2026.PNG';
import lauraPhoto from '../../assets/teachers/Laura_2026.jpg';
import triciaPhoto from '../../assets/teachers/Tricia_2026.jpg';

const TEACHERS = [
  {
    name: 'Tricia',
    style: 'Iyengar Yoga',
    accent: 'coral',
    photo: triciaPhoto,
    bio: 'Tricia has been practising Iyengar yoga for over 20 years and teaching for 18. She holds a Level 3 Iyengar certification and specializes in therapeutics, over 10yrs training and teaching experience in this specialty, beginners, women\'s and advanced classes. Her teaching is precise, patient and deeply encouraging.', 
    note: 'CIYT Level 3 & IAYT certified',
    classes: ['Iyengar — all levels', 'Therapeutic', 'Beginners', 'Women\'s'],
  },  
  {
    name: 'Laura',
    style: 'meditation as Yoga Nidra, restorative and Hatha',
    accent: 'sage',
    photo: lauraPhoto,
    bio: 'Laura Harsha Conley, E-RYT 500, took her first yoga class in college in 1998 and has had a regular practice since 2002.Laura performed in-depth, immersive study and service at the Amrit Yoga Institute from 2013-2020, residing there full time from 2017- 2020. She completed several trainings led by Amrit Desai, his daughter Kamini Desai, and senior teacher Chandrakant John Hiester, including a 500-hour Teacher Training in Meditation in Motion; Advanced Training in Yoga Nidra; and an extensive training in Yoga Therapy.*',
    note: 'RYT-500 certified',
    classes: ['Hatha', 'Yoga Nidra', 'Restorative'],
  },
   {
    name: 'Dominique',
    style: 'Rocket Yoga® & Vinyasa',
    accent: 'coral',
    photo: dominiquePhoto,
    bio: 'With more than a decade of practice and teaching experience, Dominique brings a warm, intentional, and empowering approach to yoga. This Florida native completed her 200-hour Yoga Teacher Training in 2014, has been teaching hot yoga and Power Flow & expanded her teaching credentials in 2020, becoming a certified Rocket Yoga® instructor. Her teaching is rooted in the belief that yoga is an opportunity to discover what your body is capable of while experiencing the deeper benefits of the practice—both on and beyond the mat.',
    note: 'RYT-200 & Rocket Yoga® certified',
    classes: ['Rocket Yoga®', 'Vinyasa Flow'],
  },
  {
    name: 'Kelly',
    style: 'Meditation',
    accent: 'sage',
    bio: 'Kelly has been meditating and teaching mindfulness for over a decade. Her sessions are gentle, grounding and suitable for complete beginners.',
    note: 'Mindfulness meditation teacher',
    classes: ['Guided Meditation'],
  },
];

export default function Teachers() {
  return (
    <div className="teachers-page">
      <section className="teachers__hero">
        <p className="section-label">The team</p>
        <h1 className="section-heading">Meet your guides</h1>
        <p className="teachers__hero-sub">
          Our teachers bring decades of experience, warmth and genuine care to every class.
        </p>
      </section>

      <section className="teachers__list">
        {TEACHERS.map((t, i) => (
          <div key={t.name} className={`teacher-profile ${i % 2 === 1 ? 'teacher-profile--alt' : ''}`}>
            {t.photo ? (
              <img
                src={t.photo}
                alt={t.name}
                className={`teacher-profile__avatar teacher-profile__avatar--${t.accent}`}
              />
            ) : (
              <div className={`teacher-profile__avatar teacher-profile__avatar--${t.accent}`} />
            )}
            <div className="teacher-profile__content">
              <p className="section-label">{t.style}</p>
              <h2 className="teacher-profile__name">{t.name}</h2>
              <p className="teacher-profile__bio">{t.bio}</p>
              <p className="teacher-profile__tag">{t.note}</p>
              <div className="teacher-profile__classes">
                {t.classes.map(c => (
                  <span key={c} className={`teacher-profile__tag teacher-profile__tag--${t.accent}`}>{c}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
